import { BulkActionsMenuContent } from './BulkActionsMenuContent'
import { BulkActionsMenuRoot } from './BulkActionsMenuRoot'
import { BulkActionsMenuTrigger } from './BulkActionsMenuTrigger'
import { ResolveCommentsItem } from './ResolveCommentsItem'
import { ResolveMentionsItem } from './ResolveMentionsItem'

export { useBulkActionsMenuContext } from './BulkActionsMenuContext'

export const BulkActionsMenu = Object.assign(BulkActionsMenuRoot, {
  Trigger: BulkActionsMenuTrigger,
  Content: BulkActionsMenuContent,
  ResolveCommentsItem,
  ResolveMentionsItem,
})

export type { BulkActionsMenuRootProps } from './BulkActionsMenuRoot'
export type { BulkActionsMenuTriggerProps } from './BulkActionsMenuTrigger'
export type { BulkActionsMenuContentProps } from './BulkActionsMenuContent'
